/**
 * @generated SignedSource<<8dc11c8dc3eb6df13f61f61ab206e636>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArtistPortfolioPageQuery$variables = {};
export type ArtistPortfolioPageQuery$data = {
  readonly me: {
    readonly artist: {
      readonly " $fragmentSpreads": FragmentRefs<"WeeklyStreamsSection_entity">;
    } | null;
  } | null;
  readonly portfolio: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ArtistPortfolioPage_offers" | "ArtistPortfolioRowDeal_offer">;
  } | null> | null;
};
export type ArtistPortfolioPageQuery = {
  response: ArtistPortfolioPageQuery$data;
  variables: ArtistPortfolioPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "WeeklyStreams",
    "kind": "LinkedField",
    "name": "partnershipStreamsByWeek",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "weekStartDay",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "weekEndDay",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "streams",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastActiveAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v6/*: any*/),
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileNode",
          "kind": "LinkedField",
          "name": "spotifyProfile",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ArtistNode",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNode",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v3/*: any*/),
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "PartnerNode",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releaseType",
  "storageKey": null
},
v11 = [
  (v0/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "soundLink",
        "storageKey": null
      },
      (v6/*: any*/),
      (v9/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVisible",
        "storageKey": null
      },
      (v10/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tracksCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "releaseDate",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v2/*: any*/)
        ],
        "type": "UnreleasedReleaseNode",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TrackNodeConnection",
            "kind": "LinkedField",
            "name": "tracks",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TrackNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrackNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "trackNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SoundRecordingNode",
                        "kind": "LinkedField",
                        "name": "soundRecording",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isrc",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "ReleaseNode",
        "abstractKey": null
      }
    ],
    "type": "ReleaseInterface",
    "abstractKey": "__isReleaseInterface"
  }
],
v12 = [
  (v0/*: any*/)
],
v13 = [
  (v6/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ArtistPortfolioPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistNode",
            "kind": "LinkedField",
            "name": "artist",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WeeklyStreamsSection_entity"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "OfferNode",
        "kind": "LinkedField",
        "name": "portfolio",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ArtistPortfolioPage_offers"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ArtistPortfolioRowDeal_offer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ArtistPortfolioPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistNode",
            "kind": "LinkedField",
            "name": "artist",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": (v1/*: any*/),
                    "type": "CompanyNode",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v1/*: any*/),
                    "type": "ArtistNode",
                    "abstractKey": null
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "OfferNode",
        "kind": "LinkedField",
        "name": "portfolio",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MonthlyEarningsNodeConnection",
            "kind": "LinkedField",
            "name": "monthlyEarnings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MonthlyEarningsNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MonthlyEarningsNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "partnerEarnings",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "partnerExpenses",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalStreams",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOfferAccepted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PartnerNode",
            "kind": "LinkedField",
            "name": "partner",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v7/*: any*/),
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "type": "ActorInterface",
                "abstractKey": "__isActorInterface"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pdfUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "terms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerSignature",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "artistSignature",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "willTransferCreativeAdvance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "willTransferMarketingAdvance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReleaseNodeConnection",
            "kind": "LinkedField",
            "name": "releases",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReleaseNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReleaseNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnreleasedReleaseNodeConnection",
            "kind": "LinkedField",
            "name": "unreleasedReleases",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnreleasedReleaseNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnreleasedReleaseNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistNode",
            "kind": "LinkedField",
            "name": "artist",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "type": "ActorInterface",
                "abstractKey": "__isActorInterface"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "moneyTransferAmountCents",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stripeInvoiceUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "transferRecipient",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stripeConnectedAccountApiId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReleaseNodeConnection",
                "kind": "LinkedField",
                "name": "releases",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReleaseNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReleaseNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnreleasedReleaseNodeConnection",
                "kind": "LinkedField",
                "name": "unreleasedReleases",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnreleasedReleaseNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnreleasedReleaseNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SoundRecordingNodeConnection",
                "kind": "LinkedField",
                "name": "soundRecordings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SoundRecordingNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SoundRecordingNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v12/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "OfferFeaturedDealInterface",
            "abstractKey": "__isOfferFeaturedDealInterface"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "22bb775821b096a5b6c942eecf82e02a",
    "id": null,
    "metadata": {},
    "name": "ArtistPortfolioPageQuery",
    "operationKind": "query",
    "text": "query ArtistPortfolioPageQuery {\n  me {\n    artist {\n      ...WeeklyStreamsSection_entity\n      id\n    }\n    id\n  }\n  portfolio {\n    id\n    ...ArtistPortfolioPage_offers\n    ...ArtistPortfolioRowDeal_offer\n  }\n}\n\nfragment ArtistPortfolioPage_offers on OfferNode {\n  monthlyEarnings {\n    edges {\n      node {\n        __typename\n        id\n      }\n    }\n  }\n}\n\nfragment ArtistPortfolioRowDeal_offer on OfferNode {\n  totalStreams\n  monthlyEarnings {\n    edges {\n      node {\n        partnerEarnings\n        partnerExpenses\n        id\n      }\n    }\n  }\n  dateOfferAccepted\n  partner {\n    ...AvatarName_actor\n    id\n  }\n  ...ReleaseIconsNames_query\n  ...PortfolioRowDeal_offer\n}\n\nfragment AvatarIcon_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    lastActiveAt\n    ...useUserThumbnailUrl_user\n    id\n  }\n}\n\nfragment AvatarName_actor on ActorInterface {\n  __isActorInterface: __typename\n  __typename\n  slug\n  displayName\n  ...AvatarIcon_actor\n  ... on PartnerNode {\n    company {\n      slug\n      displayName\n      id\n    }\n  }\n}\n\nfragment OfferMessageBody_offer on OfferNode {\n  dateOfferAccepted\n  status\n  terms\n  partnerSignature\n  artistSignature\n  willTransferCreativeAdvance\n  willTransferMarketingAdvance\n  releases {\n    edges {\n      node {\n        ...OfferMessageReleasesIncluded_releases\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        ...OfferMessageReleasesIncluded_unreleasedReleases\n        id\n      }\n    }\n  }\n  artist {\n    displayName\n    ...OfferPartnership_artist\n    id\n  }\n  partner {\n    displayName\n    ...OfferPartnership_partner\n    id\n  }\n  ...OfferNextStep_offer\n  ...OfferMessageReleasesIncluded_offer\n}\n\nfragment OfferMessageReleasesIncluded_offer on OfferNode {\n  ...ReleasesInfoRemovable_offerFeaturedDeal\n}\n\nfragment OfferMessageReleasesIncluded_releases on ReleaseNode {\n  id\n  ...ReleasesInfoRemovable_release\n}\n\nfragment OfferMessageReleasesIncluded_unreleasedReleases on UnreleasedReleaseNode {\n  id\n  ...ReleasesInfoRemovable_release\n}\n\nfragment OfferNextStep_offer on OfferNode {\n  moneyTransferAmountCents\n  stripeInvoiceUrl\n  partner {\n    displayName\n    id\n  }\n  artist {\n    displayName\n    id\n  }\n  transferRecipient {\n    __typename\n    user {\n      id\n    }\n    id\n  }\n  ...useOfferNextStep_offer\n}\n\nfragment OfferPartnership_artist on ArtistNode {\n  ...AvatarName_actor\n}\n\nfragment OfferPartnership_partner on PartnerNode {\n  ...AvatarName_actor\n}\n\nfragment PortfolioRowDeal_offer on OfferNode {\n  pdfUrl\n  ...OfferMessageBody_offer\n}\n\nfragment ReleaseDetails_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  isVisible\n  name\n  ...useReleaseMetadata_release\n}\n\nfragment ReleaseIconsNames_query on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  ...ReleaseIconsNames_releaseImages\n  ...useFeaturedDealTitle\n}\n\nfragment ReleaseIconsNames_releaseImages on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  releases {\n    edges {\n      node {\n        thumbnailUrl\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        thumbnailUrl\n        id\n      }\n    }\n  }\n}\n\nfragment ReleasesInfoRemovable_offerFeaturedDeal on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  soundRecordings {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment ReleasesInfoRemovable_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  id\n  soundLink\n  thumbnailUrl\n  name\n  ... on UnreleasedReleaseNode {\n    __typename\n  }\n  ... on ReleaseNode {\n    __typename\n    tracks {\n      edges {\n        node {\n          name\n          trackNumber\n          soundRecording {\n            id\n            isrc\n          }\n          id\n        }\n      }\n    }\n  }\n  ...ReleaseDetails_release\n}\n\nfragment WeeklyStreamsSection_entity on Node {\n  __isNode: __typename\n  ... on CompanyNode {\n    partnershipStreamsByWeek {\n      weekStartDay\n      weekEndDay\n      streams\n    }\n  }\n  ... on ArtistNode {\n    partnershipStreamsByWeek {\n      weekStartDay\n      weekEndDay\n      streams\n    }\n  }\n}\n\nfragment useArtistThumbnailUrl_artist on ArtistNode {\n  thumbnailUrl\n  spotifyProfile {\n    thumbnailUrl\n    id\n  }\n}\n\nfragment useFeaturedDealTitle on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  releases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n}\n\nfragment useOfferNextStep_offer on OfferNode {\n  status\n  moneyTransferAmountCents\n  transferRecipient {\n    __typename\n    user {\n      id\n      stripeConnectedAccountApiId\n    }\n    id\n  }\n  artist {\n    user {\n      id\n    }\n    id\n  }\n}\n\nfragment useReleaseMetadata_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  releaseType\n  tracksCount\n  releaseDate\n}\n\nfragment useUserThumbnailUrl_user on UserNode {\n  actor {\n    __typename\n    thumbnailUrl\n    ...useArtistThumbnailUrl_artist\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d15354f2c445b5e1fa682e4022d42d2d";

export default node;
